type TooltipOptions = {
    offset?: number;
    padding?: number;
};

export function initTooltips(options: TooltipOptions = {}) {
    const offset = options.offset ?? 8;
    const padding = options.padding ?? 8;

    const tooltips = document.querySelectorAll<HTMLElement>('.tooltip');

    tooltips.forEach((tooltip) => {
        const content = tooltip.querySelector<HTMLElement>('.tooltip-content');
        if (!content) return;

        let isVisible = false;

        const showTooltip = () => {
            content.style.display = 'block';
            content.style.left = '0px';
            content.style.top = '0px';
            content.style.transform = 'none';

            const tooltipRect = tooltip.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();

            // 👉 центрируем относительно tooltip
            let left =
                tooltipRect.left +
                tooltipRect.width / 2 -
                contentRect.width / 2;

            let top = tooltipRect.bottom + offset;

            // 👉 ограничение по горизонтали
            if (left < padding) {
                left = padding;
            }

            if (left + contentRect.width > window.innerWidth - padding) {
                left = window.innerWidth - contentRect.width - padding;
            }

            // 👉 если не помещается снизу → показываем сверху
            if (top + contentRect.height > window.innerHeight - padding) {
                top = tooltipRect.top - contentRect.height - offset;
            }

            // 👉 применяем через fixed (важно!)
            content.style.position = 'fixed';
            content.style.left = `${left}px`;
            content.style.top = `${top}px`;

            isVisible = true;
        };

        const hideTooltip = () => {
            content.style.display = 'none';
            isVisible = false;
        };

        // hover
        tooltip.addEventListener('mouseenter', showTooltip);
        tooltip.addEventListener('mouseleave', hideTooltip);

        // mobile click
        tooltip.addEventListener('click', (e) => {
            e.stopPropagation();
            isVisible ? hideTooltip() : showTooltip();
        });

        document.addEventListener('click', () => {
            if (isVisible) hideTooltip();
        });
    });
}
